import { CanvasPresetId, CatalogTabId, ShapeKind } from './templateEditor.types'

export type CanvasPreset = {
    id: CanvasPresetId
    label: string
    w: number
    h: number
}

export type CatalogTab = {
    id: CatalogTabId
    labelKey: string
}

export const canvasPresets: CanvasPreset[] = [
    { id: '1920x1080', label: '1920×1080', w: 1920, h: 1080 },
    { id: '3840x2160', label: '3840×2160', w: 3840, h: 2160 },
    { id: '1080x1920', label: '1080×1920', w: 1080, h: 1920 },
]

export const zoomPresetValues = [0.5, 0.75, 1, 1.5, 2] as const

export const gridSizeOptions = [8, 16, 32, 50, 100] as const

export const catalogTabs: CatalogTab[] = [
    { id: 'images', labelKey: 'templateEditorCatalogImages' },
    { id: 'backgrounds', labelKey: 'templateEditorCatalogBackgrounds' },
    { id: 'all', labelKey: 'templateEditorCatalogAll' },
]

export const catalogPlaceholderCount = 6

export const addToolItems = [
    { id: 'text', titleKey: 'templateEditorAddText' },
    { id: 'shape', titleKey: 'templateEditorAddShape' },
    { id: 'list', titleKey: 'templateEditorAddVerticalList' },
    { id: 'listH', titleKey: 'templateEditorAddHorizontalList' },
    { id: 'table', titleKey: 'templateEditorAddTable' },
] as const

export type AddToolId = typeof addToolItems[number]['id']

export const shapeToolItems: Array<{ id: ShapeKind; titleKey: string; icon: string }> = [
    { id: 'rect', titleKey: 'templateEditorRectangle', icon: 'shapeRect' },
    { id: 'rounded', titleKey: 'templateEditorRounded', icon: 'shapeRounded' },
    { id: 'ellipse', titleKey: 'templateEditorEllipse', icon: 'shapeEllipse' },
    { id: 'line', titleKey: 'templateEditorLine', icon: 'shapeLine' },
]

export const shapeIconByKind: Record<ShapeKind, string> = {
    rect: 'shapeRect',
    rounded: 'shapeRounded',
    ellipse: 'shapeEllipse',
    line: 'shapeLine',
}
